/* eslint-disable array-callback-return */
/* eslint-disable react/no-danger */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable no-empty */
/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import { useCallback, useContext, useRef, useState } from 'react';
import './index.css';
// 引入组件
import Chat, {
  Bubble,
  useMessages,
  Typing,
  Think,
  TypingBubble,
  FileCard,
} from '@chatui/core';
// 引入样式
import '@chatui/core/dist/index.css';
import {
  useID,
  useMcp,
  BefPage,
  BefGlobalContext,
  BefPageControllerService,
  BefPageControllerContext,
  BefMessageServiceContext,
  BefPageServiceContext,
  BefGuid,
} from '@beflam/bef-core';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import InputWithUpload from './InputWithUpload/InputWithUpload';
import { getChartRenderSchema } from './chatHelper';
import { Tab, Icon, MenuButton, Dialog, Input, Balloon } from '@alifd/next';
import FeedbackButtons from './FeedbackButons/FeedbackButtons';
import Image from '@rc-component/image';
import '@rc-component/image/assets/index.css';
import {
  chatHistoryRequest,
  downloadChatExport,
} from '../../utils/chatHistoryApi';
import useStateRef from '../../../hooks/UseStateRef';

export interface chatProps {
  value?: string;
  id?: string;
  name?: string;
  title?: string;
  logo?: string;
  system?: string;
  placeholder?: string;
  user?: string;
  usericon?: string;
  inputs?: any;
  responseMessage?: any;
  clickChatList?: any;
  isReduceChat?: any;
  style?: any;
  viewType?: string;
  closePageAction?: any;
  pageAiVisible?: boolean;
  aiUser?: any;
  initConversation?: { id: string; star: any; key: number };
  backHandler?: () => void;
}

let BefPageChatId = { conversionId: null, pageId: null } as any;

const BeflamChat: React.FC<chatProps> = function chat({
  value,
  ...otherProps
}) {
  const {
    id,
    name,
    title = '我是当前界面的专属助理',
    system = '',
    placeholder = '请输入...',
    logo,
    usericon,
    clickChatList,
    closePageAction,
    isReduceChat,
    viewType,
    pageAiVisible,
    aiUser,
    initConversation,
    backHandler,
    ..._otherProps
  } = otherProps || {};

  const ref = useID(id || name) as any;
  const sGlobal = useContext(BefGlobalContext) as any;
  const pageController: BefPageControllerService = useContext(
    BefPageControllerContext,
  );
  const pageService = useContext(BefPageServiceContext);
  const messageService = useContext(BefMessageServiceContext);

  const proxy: any = {};
  ref.current = {
    instance: proxy,
  };

  let typingMsgId = null as any; //显示思考中内容,保存id,在返回信息时关闭
  let typedMsgId = null as any; //显示正在回调时的loading,保存id,在返回信息结束时关闭
  let responseMsgId = null as any; //当前显示的内容的id
  let thinkMsgId = null as any; //thinking内容的id
  let beflamActionMessages = [] as any; //beflam action信息列表
  let beflamShowPageMessages = [] as any; //beflam showpage action信息列表

  const [sendState, setSendState] = React.useState('send') as any; //发送按钮的state
  const [showEditMsgId, setShowEditMsgId] = React.useState(null) as any; //点赞收藏的id
  const [recomentMsgIds, setRecomentMsgIds] = React.useState([]) as any; //更多信息推荐的id集合
  const [feedbackType, setFeedbackType] = React.useState({
    result: 2,
    isFavorite: false,
  }) as any; //点赞情况配置

  const [sseController, setSseController] = React.useState(null) as any; //两条信息接近时,停止上条请求
  const mcpId = React.useRef(BefGuid.newGuid());

  const pageIdRef = React.useRef('');
  const [chatId, chatIdRef, setChatId] = useStateRef({
    conversationId: '',
    researchId: '',
  });
  const [systemText, setSystemText] = React.useState(
    viewType === 'page'
      ? '你可以输入“你会什么”，我会告诉你我的技能哦。'
      : system,
  );
  const [showChatList, setShowChatList] = React.useState(false);
  const [dialogVisible, setDialogVisible] = React.useState(false);
  const [editConData, setEditConData] = React.useState({
    Id: '',
    Title: '',
    star: false,
  });
  const [defaultText, setDefaultText] = React.useState('') as any; //文本框内的默认内容

  const [aiUserName, setAiUserName] = React.useState<string>(
    aiUser?.Name || '',
  ); //AI助理Name，从prop初始化，可被接口更新

  const [defaultReasoning, setDefaultReasoning] = React.useState(
    aiUser?.DeepThink ? true : false,
  ) as any;

  const [defaultIntentionMode, setDefaultIntentionMode] = React.useState(
    aiUser?.PageMode || 'Auto',
  ) as any;

  const chatModeRef = React.useRef<string>(
    aiUser?.ChatMode || (aiUser?.AutoChat !== false ? 'Execute' : 'Input'),
  );
  const combineFirstInputRef = React.useRef<boolean>(true);

  const initialMessages = [
    {
      type: 'system',
      content: { text: systemText },
    },
  ];

  // 默认快捷短语，可选
  const defaultQuickReplies = [
    // {
    //   icon: 'message',
    //   name: '联系人工服务',
    //   isNew: true,
    //   isHighlight: true,
    // },
    {
      name: '新建聊天',
      isHighlight: true,
    },
  ];

  React.useEffect(() => {
    if (viewType !== 'page' && viewType !== 'AIUSER') {
      sseSend({
        session_id: sGlobal ? sGlobal.session.id : '', // fb00c2d9-5853-412c-8d75-3bdc074b5503',
        app_id: sGlobal ? sGlobal.currentAppId : '', // '2ba85a94-d33f-4a73-8587-a3d74ddfed2c',
        module_id: sGlobal ? sGlobal.currentModuleId : '', // 'wms',
        inputs: {},
        query: '随机生成一句激励的话, 只返回激励的话, 不要返回额外的内容',
        conversation_id: chatIdRef.current.conversationId,
        action: 'motivation',
      });
    } else {
    }
  }, []);

  React.useEffect(() => {
    if (systemText.length > 0) {
      resetList([
        {
          type: 'system',
          content: { text: systemText },
        },
        ...messages,
      ]);
    }
  }, [systemText]);

  const mcp = useMcp();
  React.useEffect(() => {
    if (viewType === 'page') {
      if (pageAiVisible) {
        const activePageId =
          pageController.activeContainer?.activePage?.state || '';
        if (pageIdRef.current !== activePageId) {
          if (pageIdRef.current !== '') {
            handleSend('clean');
          } else if (
            BefPageChatId.pageId === activePageId &&
            BefPageChatId.conversationId !== null
          ) {
            getChatHistory('get', BefPageChatId.conversationId);
          } else {
            BefPageChatId.pageId = activePageId;
            BefPageChatId.conversationId = null;
          }
          pageIdRef.current = activePageId;
        }
        (async () => {
          try {
            await mcp.start(
              pageService.appId,
              pageService.moduleId,
              activePageId,
              mcpId.current,
            );
          } catch (error: any) {
            if (error.errorType === 'FailedToNegotiateWithServerError') {
              messageService.showMessage(
                messageService.handleErr('连接Mcp服务器失败', 'Mcp'),
              );
            } else {
              messageService.showMessage(
                messageService.handleErr(error, 'Mcp'),
              );
            }
          }
        })();
      } else {
        (async () => {
          try {
            await mcp.stop();
          } catch (error: any) {
            if (error.errorType === 'FailedToNegotiateWithServerError') {
              messageService.showMessage(
                messageService.handleErr('连接Mcp服务器失败', 'Mcp'),
              );
            } else {
              messageService.showMessage(
                messageService.handleErr(error, 'Mcp'),
              );
            }
          }
        })();
      }
    }
  }, [pageAiVisible]);

  React.useEffect(() => {
    if (isReduceChat) {
      setShowChatList(false);
    }
  }, [isReduceChat]);

  React.useEffect(() => {
    if (viewType !== 'page') {
      if (viewType === '') {
        const chatMode =
          aiUser?.ChatMode ||
          (aiUser?.AutoChat !== false ? 'Execute' : 'Input');
        chatModeRef.current = chatMode;
        combineFirstInputRef.current = true;
      }
      handleSend('clean');
      setShowChatList(false);
      if (viewType === '') {
        if (aiUser?.Prompt && !initConversation?.id) {
          if (chatModeRef.current === 'Execute') {
            handleSend('text', aiUser.Prompt, {}, false, false);
          } else if (chatModeRef.current === 'Input') {
            setDefaultText(aiUser.Prompt);
          } else if (chatModeRef.current === 'Combine') {
            setDefaultText('');
          }
        }
        setDefaultReasoning(aiUser?.DeepThink || false);
        setDefaultIntentionMode(aiUser?.PageMode || 'Auto');
      }
      setAiUserName(aiUser?.Name || '');
    }
  }, [viewType, aiUser]);

  // initConversation.key 每次由调用方设为 Date.now()，保证切换同一条历史时也能重新触发
  React.useEffect(() => {
    if (initConversation?.id) {
      getChatHistory('get', initConversation.id, initConversation.star);
    }
  }, [initConversation]);

  const { messages, appendMsg, deleteMsg, updateMsg, resetList } =
    useMessages();

  // 发送回调
  const handleSend = (
    type: any,
    val: any = '',
    inputs = {} as any,
    isRecommend = false as boolean,
    showSendMessage = true,
  ) => {
    if (sseController !== null) {
      sseController.abort();
      setSseController(null);
    }

    //发送信息时去除点赞功能列表
    if (showEditMsgId !== null) {
      deleteMsg(showEditMsgId);
      setShowEditMsgId(null);
    }
    //发送信息时去除推荐列表
    if (recomentMsgIds.length > 0) {
      recomentMsgIds.map((item: any) => {
        deleteMsg(item);
      });
    }

    if (type === 'text' && val.trim()) {
      let sendVal = val;
      if (
        chatModeRef.current === 'Combine' &&
        combineFirstInputRef.current &&
        viewType === '' &&
        aiUser?.Prompt
      ) {
        combineFirstInputRef.current = false;
        sendVal = `用户输入的是${val}\n\n${aiUser.Prompt}`;
      }
      setShowChatList(false);
      if (showSendMessage) {
        appendMsg({
          type: 'text',
          content: { text: val },
          position: 'right',
          user: {
            avatar: usericon,
          },
        });
      }

      // TODO: 思考中
      typingMsgId = appendMsg({
        type: 'typing',
        user: {
          avatar: logo,
        },
      });

      const endInput =
        viewType === 'page'
          ? { pageId: pageController.activeContainer?.activePage?.state || '' }
          : {};
      const data_contents = inputs.fileIds ? inputs.fileIds : [];
      const sendJson = {
        session_id: sGlobal ? sGlobal.session.id : '',
        app_id: sGlobal ? sGlobal.currentAppId : '',
        module_id: sGlobal ? sGlobal.currentModuleId : '',
        inputs: endInput,
        query: sendVal,
        conversation_id:
          inputs.conversationId || chatIdRef.current.conversationId,
        research_id: chatId.researchId,
        is_recommended: isRecommend,
        reasoning: inputs.reasoning,
        intention_mode: inputs.intentionMode,
        data_contents,
      } as any;

      if (viewType === 'page') {
        sendJson.action = 'page';
        sendJson.mcp_id = mcpId.current;
      } else if (viewType === 'AIUSER') {
        if (!aiUser.Id) {
          handleSend('clean');
          appendMsg({
            type: 'errortext',
            content: {
              text: '请先选择所需的AI同事',
            },
            user: {
              avatar: logo,
            },
          });
          return;
        }
        sendJson.employee_id = aiUser.Id;
      } else {
        sendJson.type_id = aiUserName; //这里如果存在AI助理，要在历史中加入AI助理的Name
      }

      setSendState('stop');
      sseSend(sendJson);
    } else if (type === 'clean') {
      combineFirstInputRef.current = true;
      setFeedbackType({ result: 2, isFavorite: false });
      setChatId({ conversationId: '', researchId: '' });
      setSendState('send');
      if (viewType === 'page') {
        BefPageChatId.conversationId = null;
      } else {
        _closeAllTabs(); //关闭右侧打开的界面
      }
      if (systemText.length > 0 && viewType !== 'AIUSER') {
        const initialMsgs = [
          {
            type: 'system',
            content: { text: systemText },
          },
        ] as any;
        if (chatModeRef.current === 'Combine' && aiUser?.UserInputPrompt) {
          initialMsgs.push({
            type: 'text',
            content: { text: aiUser.UserInputPrompt },
            user: {
              avatar: logo,
            },
          });
        }
        resetList(initialMsgs);
      } else {
        resetList();
        //每次清空信息时,显示AI同事功能
        if (viewType === 'AIUSER') {
          getAIUserFunction();
        }
        if (chatModeRef.current === 'Combine' && aiUser?.UserInputPrompt) {
          appendMsg({
            type: 'text',
            content: { text: aiUser.UserInputPrompt },
            user: {
              avatar: logo,
            },
          });
        }
      }
    } else if (type === 'file') {
      appendMsg({
        type: 'file',
        content: { file: val },
        position: 'right',
        user: {
          avatar: usericon,
        },
      });
    }
  };

  // 快捷短语回调，可根据 item 数据做出不同的操作，这里以发送文本消息为例
  const handleQuickReplyClick = (item: any) => {
    if (item.name === '新建聊天') {
      handleSend('clean', item.name);
    }
  };

  const sseSend = async (message: any) => {
    const reponseMessages = [] as any;
    const reasoningMessages = [] as any;
    let conversationId = chatId.conversationId;
    try {
      let viewSseController = null;
      if (message.action !== 'motivation') {
        viewSseController = new AbortController();
        setSseController(viewSseController);
      }

      const defaultAddress =
        sGlobal && sGlobal.config ? sGlobal.config.host : '';

      let postUrl = `${defaultAddress}/api/agent/chat`;
      if (viewType === 'RESEARCH') {
        postUrl = `${defaultAddress}/api/agent/research`;
      } else if (viewType === 'AIUSER') {
        postUrl = `${defaultAddress}/api/agent/employeechat`;
      }
      // const postUrl = 'http://192.168.9.73:8076/api/agent/chat';
      // const postUrl = 'http://192.168.2.61:5300/api/agent/chat';
      // const apikey = 'app-7GobGY25ampAg6etMFWe5V5A';
      const response = await fetch(postUrl, {
        method: 'POST', // 或 POST
        headers: {
          // Authorization: `Bearer ${apikey}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(message),
        signal: viewSseController ? viewSseController.signal : undefined, // 用于终止请求
      });

      if (response.ok === false) {
        appendMsg({
          type: 'errortext',
          content: {
            text: `status:${response.status}, error:${response.statusText}`,
          },
          user: {
            avatar: logo,
          },
        });
        if (typingMsgId) {
          deleteMsg(typingMsgId);
          typingMsgId = null;
        }
        setSendState('send');
        setSseController(null);
        return;
      }

      if (response.body) {
        const reader = response.body.getReader();
        const decoder = new TextDecoder();

        let linesMessage = '';
        beflamActionMessages = [];
        beflamShowPageMessages = [];
        while (true) {
          // eslint-disable-next-line @typescript-eslint/no-shadow
          const { done, value } = await reader.read();
          if (done) break;

          const chunk = linesMessage + decoder.decode(value);
          // console.log(`chunk:${chunk}`);

          // api报错直接返回错误
          try {
            const jsonMessage = JSON.parse(chunk);
            if (jsonMessage.code) {
              appendMsg({
                type: 'errortext',
                content: { text: chunk },
                user: {
                  avatar: logo,
                },
              });
            }
            if (typingMsgId) {
              deleteMsg(typingMsgId);
              typingMsgId = null;
            }
            break;
          } catch (error) {}

          const lines = chunk
            .split('\n')
            .filter((line) => line.startsWith('data: '));

          if (lines.length === 0) {
            linesMessage += chunk;
            continue;
          } else {
            const lastLine = lines[lines.length - 1];
            const lastChar = lastLine.charAt(lastLine.length - 1);
            if (lastChar !== '}') {
              linesMessage = lastLine;
            } else {
              linesMessage = '';
            }
          }

          lines.forEach((line) => {
            const data = line.replace('data: ', '');
            let jsonData = {
              answer: '',
              reasoning_content: '',
              conversation_id: '',
              event: '',
              research_id: '',
              error: null,
            };
            try {
              jsonData = JSON.parse(data) as any;
              // console.log('Received:', jsonData);
            } catch (error) {
              console.log('parse 报错', error);
            }
            // 设置conversation_id
            if (
              chatId.conversationId === '' &&
              jsonData.conversation_id &&
              jsonData.conversation_id.length > 0 &&
              message.action !== 'motivation' &&
              conversationId !== jsonData.conversation_id
            ) {
              const chatId = {
                conversationId: jsonData.conversation_id,
                researchId: '',
              };
              conversationId = jsonData.conversation_id;
              if (viewType === 'page') {
                BefPageChatId.conversationId = conversationId;
              }
              if (jsonData.research_id && jsonData.research_id.length > 0) {
                chatId.researchId = jsonData.research_id;
              }
              setChatId(chatId);
            }

            let reponseMessage = messageResult(jsonData.answer);
            if (jsonData.event && jsonData.event === 'error') {
              reponseMessage = data;
            }
            if (jsonData.error) {
              appendMsg({
                type: 'errortext',
                content: { text: '!错误: ' + jsonData.error },
                user: {
                  avatar: logo,
                },
              });
            }
            reponseMessages.push(reponseMessage);
            if (message.action !== 'motivation') {
              updataMessage(reponseMessages, message);
            }
            if (jsonData.reasoning_content && message.action !== 'motivation') {
              reasoningMessages.push(jsonData.reasoning_content);
              updataThinkMessage(reasoningMessages.join(''));
            }
          });
        }
        setSendState('send');
        setSseController(null);
      }
    } catch (error) {
      if (typingMsgId) {
        deleteMsg(typingMsgId);
        typingMsgId = null;
      }
      if (typedMsgId) {
        deleteMsg(typedMsgId);
        typedMsgId = null;
      }
      if (thinkMsgId) {
        deleteMsg(thinkMsgId);
        thinkMsgId = null;
      }
      console.error('ssehand error:', error);
      return;
      // alert('消息发送失败，请检查连接');
    }
    if (reponseMessages.length > 0) {
      if (typingMsgId) {
        //防止只有befAction导致loading未关闭
        deleteMsg(typingMsgId);
        typingMsgId = null;
      }
      if (typedMsgId) {
        deleteMsg(typedMsgId);
        typedMsgId = null;
      }
      //新逻辑去除了thinkdown,不需要在结束时更新, 现更新只用作motivation激励词
      if (message.action === 'motivation') {
        updataMessage(reponseMessages, message, true);
      }
    }
    if (thinkMsgId) {
      updateMsg(thinkMsgId, {
        type: 'thinkdone',
        content: { text: reasoningMessages.join('') },
        user: { avatar: logo },
      });
      thinkMsgId = null;
    }
    if (message.action === 'motivation') return;

    showActionView(beflamShowPageMessages);
    //显示点赞收藏情况
    setFeedBackAndRecommend(conversationId);
  };

  //获取推荐项列表
  const getRecommendMessage = async (conversationId: string) => {
    try {
      const defaultAddress =
        sGlobal && sGlobal.config ? sGlobal.config.host : '';
      const postUrl = `${defaultAddress}/api/agent/recommend`;
      const postBody = {
        app_id: sGlobal.currentAppId,
        session_id: sGlobal.session.id,
        conversation_id: conversationId,
      } as any;

      const response = await fetch(postUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postBody),
      });

      if (response.ok === false) {
        //获取失败
        return;
      }
      const data = await response.json();
      // console.log('反馈结果:' + JSON.stringify(data));
      if (data.code === 0 && data.data) {
        const recommendIds = [] as any;
        if (data.data.recommends) {
          data.data.recommends.map((message: any) => {
            const recommendId = appendMsg({
              type: 'recommend',
              content: { text: message },
              user: {
                avatar: logo,
              },
            });
            recommendIds.push(recommendId);
          });
        }
        if (data.data.pictures) {
          data.data.pictures.map((message: any) => {
            appendMsg({
              type: 'image',
              content: {
                picUrl: defaultAddress + '/' + message,
              },
              user: {
                avatar: logo,
              },
            });
          });
        }
        setRecomentMsgIds(recommendIds);
      }
    } catch (error) {
      console.error('recommend error:', error);
      // alert('消息发送失败，请检查连接');
    }
  };

  //获取ai同事功能信息
  const getAIUserFunction = async () => {
    try {
      const defaultAddress =
        sGlobal && sGlobal.config ? sGlobal.config.host : '';
      const postUrl = `${defaultAddress}/api/agent/employee/${aiUser.Id}`;

      const response = await fetch(postUrl, {
        method: 'get', // 或 POST
        headers: {
          Authorization: `Bearer ${sGlobal.session.id}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok === false) {
        //获取失败
        return;
      }
      const data = await response.json();
      // console.log('获取ai同事反馈结果:' + JSON.stringify(data));
      if (data.code === 0 && data.data && data.data.functionInfo) {
        setSystemText(data.data);
        if (data.data.name) {
          setAiUserName(data.data.name);
        }
        appendMsg({
          type: 'text',
          content: { text: data.data.functionInfo },
          user: {
            avatar: logo,
          },
        });
      }
    } catch (error) {
      console.error('recommend error:', error);
      // alert('消息发送失败，请检查连接');
    }
  };

  const showActionView = (
    beflamShowPageMessages: any,
    postAction: Boolean = true,
  ) => {
    if (beflamShowPageMessages.length > 0) {
      if (postAction) {
        for (let index = 0; index < beflamShowPageMessages.length; index++) {
          const element = beflamShowPageMessages[index];
          if (element.action === 'ShowPage' || element.action === 'ShowChart') {
            actionClick(element);
            break;
          }
        }
      }
      appendMsg({
        type: 'actionmessage',
        content: {
          text: 'showAction',
          actions: beflamShowPageMessages,
        },
        user: {
          avatar: logo,
        },
      });
    }
  };

  const updataMessage = (
    contextMessages: any[],
    postMessage: any,
    restartMessage: boolean = false,
  ) => {
    const reponseMessages = contextMessages;
    let reponseMessage = '';
    reponseMessages.forEach((msg) => {
      reponseMessage += messageResult(msg);
    });
    updataMessageString(reponseMessage, postMessage, restartMessage);
  };

  const updataMessageString = (
    reponseMessage: any,
    postMessage: any,
    restartMessage: boolean = false,
  ) => {
    // console.log(reponseMessage);
    beflamActionMessages.forEach((beflamActionMessage: any) => {
      reponseMessage = reponseMessage.replace(beflamActionMessage, '');
    });
    reponseMessage = getBeflamMessage(
      reponseMessage,
      '<BeflamAction>',
      '</BeflamAction>',
    );
    // 修复历史记录中多个BeflamAction情况;
    while (
      reponseMessage.indexOf('<BeflamAction>') >= 0 &&
      reponseMessage.indexOf('</BeflamAction>') > 0
    ) {
      reponseMessage = getBeflamMessage(
        reponseMessage,
        '<BeflamAction>',
        '</BeflamAction>',
      );
    }
    reponseMessage = getBeflamMessage(
      reponseMessage,
      '<BefAction>',
      '</BefAction>',
    );

    while (reponseMessage.indexOf('\n') === 0) {
      reponseMessage = reponseMessage.replace(/^\n/, '');
    }

    if (postMessage.action === 'motivation') {
      setSystemText(reponseMessage);
      return;
    }

    if (reponseMessage.length > 0 && typingMsgId) {
      deleteMsg(typingMsgId);
      typingMsgId = null;
    }

    // console.log(reponseMessage);
    // console.log(JSON.stringify(reponseMessage));
    // console.log(converter.makeHtml(reponseMessage));

    if (responseMsgId === null) {
      if (reponseMessage.length > 0) {
        responseMsgId = appendMsg({
          type: 'text',
          content: { text: reponseMessage },
          user: {
            avatar: logo,
          },
        });
        // TODO: 回答过程中...
        typedMsgId = appendMsg({
          type: 'typing',
          user: {
            avatar: logo,
          },
        });
      }
    } else if (reponseMessage.length === 0) {
      deleteMsg(responseMsgId);
      responseMsgId = null;
    } else {
      updateMsg(responseMsgId, {
        type: 'text',
        content: { text: reponseMessage },
        user: {
          avatar: logo,
        },
      });
      if (typedMsgId !== null) {
        updateMsg(typedMsgId, {
          type: 'typing',
          user: {
            avatar: logo,
          },
        });
      }
    }
  };

  const updataThinkMessage = (thinkContent: string) => {
    if (thinkMsgId === null) {
      if (thinkContent.length > 0) {
        thinkMsgId = appendMsg({
          type: 'think',
          content: { text: thinkContent },
          user: { avatar: logo },
        });
      }
    } else {
      updateMsg(thinkMsgId, {
        type: 'think',
        content: { text: thinkContent },
        user: { avatar: logo },
      });
    }
  };

  const getBeflamMessage = (
    data: any,
    searchStr: string,
    endSearchStr: string,
  ) => {
    const index = data.indexOf(searchStr);

    if (index !== -1) {
      // 截取从searchStr开始到endSearchStr结束标识的字符串
      const endIndex = data.indexOf(endSearchStr, index + searchStr.length);
      if (endIndex === -1) {
        // 如果没有找到结束标识，就截取到字符串末尾
        return data.substring(0, index);
      } else {
        const actionMessage = data.substring(
          index,
          endIndex + endSearchStr.length,
        );
        if (!beflamActionMessages.includes(actionMessage)) {
          beflamActionMessages.push(actionMessage);
          beflamAction(actionMessage);
        }
        if (data.length === endIndex + endSearchStr.length) {
          return data.substring(0, index);
        } else {
          return (
            data.substring(0, index) +
            data.substring(endIndex + endSearchStr.length)
          );
        }
      }
    } else if (data.length > 3) {
      const searchObscureStr = '<Be';
      const obsIndex = data.indexOf(searchObscureStr);
      if (obsIndex >= 0 && data.length - obsIndex < 17) {
        return data.substring(0, obsIndex);
      }
    } else if (
      data === '<' ||
      data === '<B' ||
      data === '<Be' ||
      data === '<Bef'
    ) {
      return '';
    }
    return data;
  };

  const beflamAction = (message: any, postMessage: boolean = true) => {
    const index = message.indexOf('{');
    const endIndex = message.lastIndexOf('}');
    let actionMessage = {} as any;
    if (index > 0 && endIndex > 0) {
      const getArrMsg = message.substring(index, endIndex + 1);
      try {
        actionMessage = JSON.parse(getArrMsg);
      } catch (error) {}
    }
    if (
      actionMessage.action === 'ShowPage' ||
      actionMessage.action === 'ShowChart'
    ) {
      beflamShowPageMessages.push(actionMessage);
    } else if (actionMessage.action) {
      const postmessage = {
        action: actionMessage.action,
        data: actionMessage.data,
      };
      if (postMessage && viewType === 'page') {
        if (viewType === 'page') closePageAction?.();
        pageService.page.doAction('pagechat', postmessage);
      }
    }
  };

  const messageResult = (msg: any) => {
    // 根据消息类型来渲染
    switch (msg) {
      case '<think>':
      case '</think>':
        return '';
      case undefined:
        return '';
      default:
        return msg;
    }
  };

  const renderMessageContent = (msg: any) => {
    const { type, content } = msg;

    // 根据消息类型来渲染
    switch (type) {
      case 'text':
        return (
          <Bubble type="text">
            <div className="bef-markdown-container">
              <Markdown remarkPlugins={[remarkGfm]}>{content.text}</Markdown>
            </div>
          </Bubble>
        );
      case 'errortext':
        return (
          <Bubble type="text">
            <div className="chat-error">{content.text}</div>
          </Bubble>
        );
      case 'image':
        return (
          <Bubble type="image">
            <div style={{ padding: 20 }}>
              <Image
                key={content.picUrl}
                src={content.picUrl}
                preview={{
                  icons: { close: null },
                }}
              />
            </div>
          </Bubble>
        );
      case 'typing':
        return <Typing />;
      case 'think':
        return (
          <Bubble>
            <Think>
              <div className="bef-markdown-container">
                <Markdown remarkPlugins={[remarkGfm]}>{content.text}</Markdown>
              </div>
            </Think>
          </Bubble>
        );
      case 'thinkdone':
        return (
          <Bubble>
            <Think isDone>
              <div className="bef-markdown-container">
                <Markdown remarkPlugins={[remarkGfm]}>{content.text}</Markdown>
              </div>
            </Think>
          </Bubble>
        );
      case 'bubble':
        return (
          <TypingBubble
            content={content.text}
            isRichText
            options={{ step: [20, 50], interval: 100 }}
          />
        );
      case 'actionmessage':
        const { actions = [] } = content;
        // console.log('回调内容:' + JSON.stringify(content));
        const actionList = [];
        for (let index = 0; index < actions.length; index++) {
          const element = actions[index];
          actionList.push(
            <div
              className="bef-chat-actionbutton"
              style={{
                marginLeft: index > 0 ? 10 : 0,
              }}
              onClick={(evt) => actionClick(element)}
            >
              {element.data.Text || element.data.text}
            </div>,
          );
        }
        return (
          <Bubble>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              {actionList}
            </div>
          </Bubble>
        );
      case 'file':
        return <FileCard file={content.file}></FileCard>;
      case 'editmsg':
        return (
          <Bubble className="bef-chat-editcontainer">
            <FeedbackButtons
              feedbackResult={feedbackType.result}
              isFavorite={feedbackType.isFavorite}
              viewType={viewType}
              collectCallback={collectCallback}
              feedbackCallback={feedbackCallback}
            />
          </Bubble>
        );
      case 'recommend':
        return (
          <Bubble className="bef-chat-editcontainer">
            <div
              className="bef-chat-recommendbutton"
              style={{}}
              onClick={(evt) => recommendClick(content.text)}
            >
              {content.text + '  →'}
            </div>
          </Bubble>
        );
      default:
        return null;
    }
  };

  //收藏按键点击事件
  const collectCallback = (collect: boolean) => {
    const feedbackResult = {
      result: feedbackType.result,
      isFavorite: collect,
    };
    setFeedbackType(feedbackResult);
    getChatHistory('save', chatId.conversationId, collect);
  };

  //整体评价点击事件
  const feedbackCallback = async (value: string, rate: number) => {
    const feedbackResult = {
      result: rate,
      isFavorite: feedbackType.isFavorite,
    };
    setFeedbackType(feedbackResult);
    if (rate === 2) return;

    try {
      const defaultAddress =
        sGlobal && sGlobal.config ? sGlobal.config.host : '';
      const postUrl = `${defaultAddress}/api/agent/chathistory`;
      const postBody = {
        app_id: sGlobal.currentAppId,
        session_id: sGlobal.session.id,
        rate: rate,
        comments: value,
      } as any;

      const response = await fetch(postUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postBody),
      });

      // if (response.ok === false) {
      //   //获取失败
      //   return;
      // }
      // const data = await response.json();
      // console.log('反馈结果:' + JSON.stringify(data));
    } catch (error) {
      console.error('feedback error:', error);
      // alert('消息发送失败，请检查连接');
    }
  };

  //推荐项点击事件
  const recommendClick = (value: any) => {
    // console.log('推荐内容是:' + value);
    handleSend('text', value, {}, true);
  };

  //action点击事件
  const actionClick = (actionMessage: any) => {
    // console.log('showAction:' + JSON.stringify(actionMessage));
    if (isReduceChat) setShowChatList(false);
    _closeAllTabs();
    if (viewType === 'page') closePageAction?.();
    setTimeout(() => {
      if (actionMessage.action === 'ShowChart') {
        const chatPage = createChartPage(actionMessage.data);
        pageController.show(chatPage, '');
      } else if (actionMessage.action === 'ShowPage') {
        const page = new BefPage(
          actionMessage.data.ModuleId || '',
          '',
          actionMessage.data.PageId,
        );
        (page.viewState as any).queryWheres = actionMessage.data.queryWheres;
        if (actionMessage.data.pageData) {
          //目前在新增的时候，如果有初始数据，需要设置为needLoad为true
          //但是乐乐说别的界面设置为true也没问题，所以这里统一设置为true
          (page.viewState as any).needLoad = true;
          page.pageData.fromDataObject(actionMessage.data.pageData);
        }
        //如果返回了inputs中有importFile，要赋值给viewState
        if (actionMessage.data.inputs)
          (page.viewState as any).importFile =
            actionMessage.data.inputs.importFile;
        pageController.show(page, '');
      }
    }, 1);
  };

  //chat在时触发关闭侧边page事件
  const _closeAllTabs = () => {
    var len = pageController.pageContainers.length;
    for (let i = len - 1; i > -1; i--) {
      pageController.close(pageController.pageContainers[i]);
    }
  };

  const createChartPage = (schema: any) => {
    let reportPage = new BefPage(schema.moduleId || '', '', 'chart');
    reportPage.title = schema.text;
    reportPage.renderSchema = getChartRenderSchema(schema);
    return reportPage;
  };

  const response = (text: any, data: any) => {
    setDefaultText('');
    if (data.fileIds) {
      if (data.files) {
        for (let index = 0; index < data.files.length; index++) {
          const fileItem = data.files[index];
          const renamedFile = new File([fileItem.file], fileItem.fileName, {
            type: fileItem.file.type,
          });
          handleSend('file', renamedFile);
        }
        const inputChatId = data.chatId;
        if (inputChatId.conversationId) {
          if (viewType === 'page') {
            BefPageChatId.conversationId = inputChatId.conversationId;
          }
          setChatId((prev: any) => ({
            ...prev,
            conversationId: inputChatId.conversationId,
          }));
        }
        handleSend('text', text, {
          reasoning: data.reasoning,
          fileIds: data.fileIds,
          conversationId: inputChatId.conversationId,
          intentionMode: data.intentionMode,
        });
      } else {
        appendMsg({
          type: 'text',
          content: { text: '文件未上传成功, 请确认。' },
          user: {
            avatar: usericon,
          },
        });
      }
      return;
    } else if (data.stopload) {
      setSendState('send');
      if (sseController !== null) {
        sseController.abort();
        setSseController(null);
      }
      return;
    } else if (data.waitingForUpload) {
      appendMsg({
        type: 'errortext',
        content: {
          text,
        },
        position: 'right',
        user: {
          avatar: logo,
        },
      });
      return;
    }

    handleSend('text', text);
  };

  const MemoizedCustomComposer = useCallback(
    (props: any) => {
      return (
        <InputWithUpload
          response={response}
          sendState={sendState}
          chatId={chatId}
          viewType={viewType}
          defaultText={defaultText}
          reasoning={defaultReasoning}
          intentionMode={defaultIntentionMode}
          onReasoningChange={onReasoningChange}
          onIntentionModeChange={onIntentionModeChange}
        />
      );
    },
    [
      sseController,
      chatId,
      showEditMsgId,
      recomentMsgIds,
      viewType,
      sendState,
      defaultReasoning,
      defaultIntentionMode,
    ],
  );

  const onReasoningChange = (reasoning: any) => {
    setDefaultReasoning(reasoning);
  };

  const onIntentionModeChange = (intentionMode: any) => {
    setDefaultIntentionMode(intentionMode);
  };

  const openChatList = () => {
    setShowChatList(true);
    getChatHistory('list');
    clickChatList?.();
  };

  const getChatHistory = async (
    action: any,
    id: any = '',
    star: any = false,
  ) => {
    try {
      const postBody = {
        action: action,
        app_id: sGlobal.currentAppId,
        session_id: sGlobal.session.id,
      } as any;
      if (action === 'save') {
        if (editConData.Title.length > 0) {
          postBody.title = editConData.Title;
        } else {
          postBody.star = star;
        }
        postBody.conversation_id = id;
      } else if (action === 'list') {
        if (star) postBody.star = true;
        postBody.type = viewType;
      } else if (action === 'delete' || action === 'get') {
        postBody.conversation_id = id;
        if (viewType === 'page') {
          postBody.type = 'page';
        }
      }
      if (viewType === 'AIUSER') {
        postBody.type = 'AGENT';
        postBody.type_id = aiUser.Id;
      } else {
        postBody.type_id = aiUser?.Name;
      }

      let refresh = false;
      if (action === 'save' && editConData.Title) {
        setEditConData({ ...editConData, Title: '', Id: '' });
        refresh = true;
      }

      const data = await chatHistoryRequest(sGlobal, postBody);
      if (!data) return;
      // console.log('data:' + JSON.stringify(data));
      if (data && data.code === 0) {
        if (action === 'list' && data.data) {
          if (star) {
            setStarItems(data.data);
          } else {
            setItems(data.data);
          }
        } else if (action === 'save') {
          //收藏结果
          if (refresh) {
            getChatHistory('list', '', star);
          } else if (!star) {
            getChatHistory('list', '', true);
          }
        } else if (action === 'delete') {
          getChatHistory('list', '', star);
        } else if (action === 'get') {
          showHistoryConversation(data, star);
        }
      } else if ((data && data.code, data.message)) {
        messageService.showMessage(
          messageService.handleErr(data.message, '历史记录'),
        );
      }
    } catch (error) {
      console.error('chatlist error:', error);
      // alert('消息发送失败，请检查连接');
    }
  };

  const showHistoryConversation = (data: any, star: any) => {
    if (data.data && data.data.Messages) {
      handleSend('clean');
      const id = data.data.Id || '';
      const researchid = data.data.ResearchId || '';
      setChatId({ conversationId: id, researchId: researchid });
      const messages = data.data.Messages;
      messages.map((item: any, index: number) => {
        const { Role, Text } = item;
        if (Role === 'user') {
          appendMsg({
            type: 'text',
            content: { text: Text },
            position: 'right',
            user: {
              avatar: usericon,
            },
          });
        } else if (Role === 'assistant') {
          beflamActionMessages = [];
          beflamShowPageMessages = [];
          responseMsgId = null;
          updataMessageString(Text, '');
          //显示逻辑导致loading未关闭,此处强制关闭
          if (typedMsgId) {
            deleteMsg(typedMsgId);
            typedMsgId = null;
          }
          showActionView(beflamShowPageMessages, false);
        }
      });

      if (star === 1) {
        const feedbackResult = {
          result: feedbackType.result,
          isFavorite: true,
        };
        setFeedbackType(feedbackResult);
      }
      //显示点赞收藏情况
      setFeedBackAndRecommend(id);
    }
  };

  //下载聊天记录
  const handleDownloadChat = async () => {
    if (!chatId.conversationId) return;
    try {
      const response = await downloadChatExport(sGlobal, chatId.conversationId);
      if (response.status !== 200) {
        let errMsg = `下载失败，HTTP状态：${response.status}`;
        try {
          const text = await response.text();
          if (text && text.length > 0) {
            errMsg += `\n${text}`;
          }
        } catch (_) {}
        messageService.showMessage(
          messageService.handleErr(errMsg, '下载聊天记录'),
        );
        return;
      }
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = `${chatId.conversationId}.txt`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      messageService.showMessage(
        messageService.handleErr(String(error), '下载聊天记录'),
      );
    }
  };

  //显示点赞收藏内容和推荐信息
  const setFeedBackAndRecommend = (conversationId: string) => {
    if (viewType !== 'AIUSER') {
      if (viewType !== 'page') {
        const editMsgId = appendMsg({
          type: 'editmsg',
          content: { text: 'reponseMessage' },
          user: {
            avatar: logo,
          },
        });
        setShowEditMsgId(editMsgId);
      }
      getRecommendMessage(conversationId);
    }
  };

  const onTabChange = (key: any) => {
    if (key === 'history') {
      getChatHistory('list');
    } else {
      getChatHistory('list', '', true);
    }
  };

  //历史记录列表内容 后续包含title, id, star, feedback
  type ItemType = {
    Title: string;
    Id: string;
    Star: any;
    Date?: string;
  };

  const formatChatDate = (dateStr: string) => {
    if (!dateStr) return '';
    const match = dateStr.match(
      /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/,
    );
    if (match) {
      return `${match[1]}年${match[2]}月${match[3]}日 ${match[4]}:${match[5]}:${match[6]}`;
    }
    return dateStr;
  };
  const [items, setItems] = useState<ItemType[]>([]);
  const [starItems, setStarItems] = useState<ItemType[]>([]);
  const { Item } = MenuButton;
  const menu = ['重命名', '收藏', '删除'].map((item) => (
    <Item key={item}>{item}</Item>
  ));
  const starmenu = ['重命名', '取消收藏', '删除'].map((item) => (
    <Item key={item}>{item}</Item>
  ));

  const menuEdit = (item: ItemType, key: string, star: boolean = false) => {
    if (key === '收藏') {
      getChatHistory('save', item.Id, true);
    } else if (key === '取消收藏') {
      getChatHistory('save', item.Id, false);
    } else if (key === '删除') {
      getChatHistory('delete', item.Id, star);
    } else if (key === '重命名') {
      setEditConData({ Id: item.Id, star, Title: item.Title });
      setDialogVisible(true);
    }
  };

  const renderList = (data: ItemType[], star: boolean = false) => (
    <div>
      {data.map((item, index) => (
        <div
          key={item.Title + BefGuid.newGuid()}
          className="chat-list-item"
          onClick={() => getChatHistory('get', item.Id, item.Star)}
        >
          <span
            className="chat-list-itemtext"
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            <span>{item.Title}</span>
            {item.Date && (
              <span
                style={{ fontSize: '0.8em', color: '#999', lineHeight: 1.4 }}
              >
                {formatChatDate(item.Date)}
              </span>
            )}
          </span>
          <MenuButton
            label={null}
            className="chat-list-itembutton"
            onClick={(e) => {
              e.stopPropagation();
            }}
            onItemClick={(key) => menuEdit(item, key, star)}
          >
            {star ? starmenu : menu}
          </MenuButton>
        </div>
      ))}
    </div>
  );

  const onOk = (e: any) => {
    if (editConData.Title.length > 0) {
      setDialogVisible(false);
      getChatHistory('save', editConData.Id, editConData.star);
    } else {
      //弹窗提示title不能为空
      messageService.showMessage(
        messageService.handleErr('Title不能为空', '修改Title'),
      );
    }
  };
  const onClose = (e: any) => {
    setDialogVisible(false);
    setEditConData({ ...editConData, Title: '' });
  };

  const onChange = (v: any) => {
    setEditConData({ ...editConData, Title: v });
  };

  return (
    <div className="bef-chattext" {..._otherProps}>
      <div
        style={{
          display: viewType === 'page' ? 'none' : 'flex',
          width: showChatList ? 240 : 48,
          zIndex: 100,
          height: '100%',
          borderRadius: 8,
          overflow: 'hidden',
          borderRight: '1px solid #e0e0e0',
          flexDirection: 'column',
          alignItems: showChatList ? 'flex-start' : 'center',
          padding: showChatList ? '12px 8px' : '16px 8px',
          backgroundColor: 'white',
          boxShadow: '2px 0 8px rgba(0, 0, 0, 0.08)',
          transition: 'all 0.3s ease',
        }}
      >
        {!showChatList && (
          <div
            style={{
              display: 'flex',
              alignSelf: 'stretch',
              alignItems: 'center',
              flexDirection: 'column',
              gap: 16,
            }}
          >
            {backHandler && (
              <Balloon.Tooltip
                popupStyle={{
                  backgroundColor: 'white',
                  borderRadius: 6,
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                }}
                v2
                align="r"
                trigger={
                  <div
                    style={{
                      padding: 8,
                      borderRadius: 8,
                      cursor: 'pointer',
                      transition: 'background-color 0.2s ease',
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = '#f5f5f5')
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = 'transparent')
                    }
                    onClick={backHandler}
                  >
                    <Icon
                      type="arrow-left"
                      size="medium"
                      style={{ color: '#666' }}
                    />
                  </div>
                }
                triggerType="hover"
              >
                返回
              </Balloon.Tooltip>
            )}
            <Balloon.Tooltip
              popupStyle={{
                backgroundColor: 'white',
                borderRadius: 6,
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
              }}
              v2
              align="r"
              trigger={
                <div
                  style={{
                    padding: 8,
                    borderRadius: 8,
                    cursor: 'pointer',
                    transition: 'background-color 0.2s ease',
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = '#f5f5f5')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = 'transparent')
                  }
                  onClick={openChatList}
                >
                  <Icon
                    type="toggle-right"
                    size="medium"
                    style={{ color: '#666' }}
                  />
                </div>
              }
              triggerType="hover"
            >
              显示聊天列表
            </Balloon.Tooltip>
            <Balloon.Tooltip
              popupStyle={{
                backgroundColor: 'white',
                borderRadius: 6,
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
              }}
              v2
              align="r"
              trigger={
                <div
                  style={{
                    padding: 8,
                    borderRadius: 8,
                    cursor: 'pointer',
                    transition: 'background-color 0.2s ease',
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = '#f5f5f5')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = 'transparent')
                  }
                  onClick={() => handleSend('clean')}
                >
                  <Icon type="edit" size="medium" style={{ color: '#666' }} />
                </div>
              }
              triggerType="hover"
            >
              新建聊天
            </Balloon.Tooltip>
            {chatId.conversationId && (
              <Balloon.Tooltip
                popupStyle={{
                  backgroundColor: 'white',
                  borderRadius: 6,
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                }}
                v2
                align="r"
                trigger={
                  <div
                    style={{
                      padding: 8,
                      borderRadius: 8,
                      cursor: 'pointer',
                      transition: 'background-color 0.2s ease',
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = '#f5f5f5')
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = 'transparent')
                    }
                    onClick={handleDownloadChat}
                  >
                    <Icon
                      type="download"
                      size="medium"
                      style={{ color: '#666' }}
                    />
                  </div>
                }
                triggerType="hover"
              >
                下载聊天记录
              </Balloon.Tooltip>
            )}
          </div>
        )}
        {showChatList && (
          <div
            style={{
              display: 'flex',
              alignSelf: 'stretch',
              flexDirection: 'row',
              alignItems: 'center',
              paddingBottom: 12,
              borderBottom: '1px solid #f0f0f0',
              marginBottom: 12,
            }}
          >
            {viewType === 'AIUSER' ? (
              <i
                className="glyphicon glyphicon-user"
                style={{ fontSize: 18, color: '#666', marginLeft: 4 }}
                aria-hidden="true"
              />
            ) : (
              <svg
                viewBox="0 0 1024 1024"
                width="18"
                height="18"
                fill="#666"
                style={{ marginLeft: 4 }}
              >
                {viewType === 'RESEARCH' ? (
                  <path
                    d="M576 320 a192 192 0 1 0 -384 0 a192 192 0 1 0 384 0 M576 320 a128 128 0 1 0 -256 0 a128 128 0 1 0 256 0 M576 320 a64 64 0 1 0 -128 0 a64 64 0 1 0 128 0 M652.8 396.8 L870.4 614.4 M128 704 h512 M128 806.4 h512 M128 908.8 h512"
                    stroke="#666"
                    stroke-width="64"
                    fill="none"
                    stroke-linecap="round"
                    stroke-line-join="round"
                  />
                ) : (
                  <path d="M269.69088 302.45888c0 37.81632 30.65856 68.46464 68.46464 68.46464s68.46464-30.64832 68.46464-68.46464c0-37.80608-30.65856-68.46464-68.46464-68.46464s-68.46464 30.65856-68.46464 68.46464zM899.54304 1.21856H123.63776c-20.19328 0-36.51584 16.32256-36.51584 36.51584v753.09056c0 20.19328 16.32256 36.5056 36.51584 36.5056h775.90528c20.19328 0 36.5056-16.31232 36.5056-36.5056V37.7344c0.01024-20.19328-16.30208-36.51584-36.5056-36.51584zM863.0272 754.30912H160.14336V74.25024H863.0272v680.05888zM616.56064 302.45888c0 37.81632 30.65856 68.46464 68.46464 68.46464 37.81632 0 68.46464-30.64832 68.46464-68.46464 0-37.80608-30.64832-68.46464-68.46464-68.46464-37.80608 0-68.46464 30.65856-68.46464 68.46464z m285.4912 634.4192H121.12896c-18.82112 0-34.00704 16.32256-34.00704 36.51584v41.07264c0 5.02784 3.76832 9.13408 8.448 9.13408h831.92832c4.67968 0 8.448-4.10624 8.448-9.13408v-41.07264c0.11264-20.20352-15.06304-36.51584-33.8944-36.51584zM685.02528 507.84256H338.15552c-5.0176 0-9.12384 4.10624-9.12384 9.13408v68.46464c0 5.0176 4.10624 9.12384 9.12384 9.12384h346.88c5.0176 0 9.13408-4.10624 9.13408-9.12384v-68.46464c-0.01024-5.02784-4.11648-9.13408-9.14432-9.13408z m0 0"></path>
                )}
              </svg>
            )}
            <div
              style={{
                flex: 1,
                fontSize: 18,
                paddingLeft: 12,
                fontWeight: 600,
                alignItems: 'center',
                color: '#333',
              }}
            >
              {viewType === 'RESEARCH'
                ? '深度研究'
                : viewType === 'AIUSER'
                  ? 'AI同事'
                  : 'AI助理'}
            </div>
            <div
              style={{
                padding: 6,
                borderRadius: 6,
                cursor: 'pointer',
                transition: 'background-color 0.2s ease',
                marginRight: 4,
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = '#f5f5f5')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = 'transparent')
              }
              onClick={() => setShowChatList(false)}
            >
              <Icon
                type="toggle-left"
                size="medium"
                style={{ color: '#666' }}
              />
            </div>
          </div>
        )}
        {showChatList && (
          <div className="chatlist-newchat" onClick={() => handleSend('clean')}>
            <Icon
              type="edit"
              size={'small'}
              className="chatlist-newchat-icon"
            />
            <div style={{ fontSize: 15, fontWeight: 500 }}>新聊天</div>
          </div>
        )}
        {showChatList ? (
          <div className="chat-list">
            <h2>聊天记录</h2>
            <Tab onChange={onTabChange} size="medium">
              <Tab.Item title="最近记录" key="history">
                {renderList(items)}
              </Tab.Item>
              <Tab.Item title="收藏" key="collect">
                {renderList(starItems, true)}
              </Tab.Item>
            </Tab>
          </div>
        ) : null}
      </div>
      <div
        style={{
          flex: 1,
          display: 'flex',
          position: 'relative',
          overflow: 'hidden',
        }}
        onClick={() => {
          if (showChatList) setShowChatList(false);
        }}
      >
        <Chat
          navbar={{
            title:
              viewType === 'AIUSER'
                ? aiUserName || ''
                : sGlobal.session.userName && viewType !== 'page'
                  ? '您好, ' + sGlobal.session.userName + '。'
                  : title,
          }}
          placeholder={placeholder}
          messages={messages}
          renderMessageContent={renderMessageContent}
          quickReplies={viewType !== 'page' ? [] : defaultQuickReplies}
          onQuickReplyClick={
            viewType !== 'page' ? () => {} : handleQuickReplyClick
          }
          onSend={handleSend}
          Composer={MemoizedCustomComposer}
        />
      </div>
      <Dialog
        v2
        title="修改Title"
        visible={dialogVisible}
        onOk={onOk}
        onClose={onClose}
      >
        <Input
          autoFocus
          size="large"
          onChange={onChange}
          aria-label="Large"
          defaultValue={editConData.Title}
        />
      </Dialog>
    </div>
  );
};

BeflamChat.displayName = 'BeflamChat';
export default BeflamChat;
